import GoogleMapMarker from './GoogleMapMarker.vue';

export { GoogleMapMarker };
export default GoogleMapMarker;
